import { put } from 'redux-saga/effects';
import {
PRESUPUESTADOR_DISABLE_BTN_SAVE_SUCCESS
} from '../constants';


export default function* disableBtnSaveSaga() {
        yield put({
            type: PRESUPUESTADOR_DISABLE_BTN_SAVE_SUCCESS,
        })
}
